import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom'
import { api } from '../../api/api';
import axios from 'axios';
import { addUser, loginSuccess } from '../../redux/authRedux';
import Swal from 'sweetalert2';
import MD5 from 'crypto-js/md5';

const DefaultIndexPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const nav = useNavigate()

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    var uuid = navigator.userAgent

    var regex = /.*\(([^)]+)\)/
    var matches = regex.exec(uuid)
    // const deviceId = AES.encrypt(matches[1], 'test-key')
    const deviceId = MD5(matches[1]).toString()
    // console.log("Device ID:", deviceId);
    useEffect(() => {
        if (token) {
            setlogin()
            localStorage.setItem("token", token)

        }
    }, [])
    const setlogin = () => {

        const data = {
            token: token,
            deviceId: deviceId,
        };

        api.post("auth/login/redirect", data)
            .then(function (response) {
                console.log(response.data, "password");
                dispatch(loginSuccess());
                dispatch(addUser(response.data));
                if (response.data.data.user.isAdmin === true) {
                    setTimeout(() => {
                        navigate("/category");
                    }, 2000);

                }
                console.log(response.data, 'data')
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("shopID", response.data.data?.user?.relatedShop?._id);
            })


    };
    return (
        <div className="">

            <h3 className='text-center'>Please Wait...</h3>

        </div>

    )
}

export default DefaultIndexPage